import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
export const NiceSelect = () =>{

  function calcHeight(nbLine){
    let calc = 19*nbLine
    return calc+"px"
    }

    return(
    
        <div id="articleContent">
         <h2>Select basique</h2>
                    <form action="test">
                        <label for="pet-select">Choisir un animal</label>
                        <select name="pets" id="pet-select">
                            <option value selected>--Please choose an option--</option>
                            <option value="dog">Dog</option>
                            <option value="cat">Cat</option>
                            <option value="hamster">Hamster</option>
                            <option value="parrot">Parrot</option>
                            <option value="spider">Spider</option>
                            <option value="goldfish">Goldfish</option>
                        </select>
                        <hr/>


                        <div class="nice-select">
                            <div>Filtrer</div>
                            <input class="choose-list" type="checkbox" id="all" value="" name="choose-list" />
                            <label class="choose-list" for="all">Tous</label>
                            <input class="choose-list" type="checkbox" id="dog" value="dog" name="choose-list"/>
                            <label class="choose-list" for="dog">Dog</label>
                            <input class="choose-list" type="checkbox" id="hamster" value="hamster" name="choose-list"/>
                            <label class="choose-list" for="hamster">Hamster</label>
                            <div>Modifier le filte</div>
                        </div>


                        
                    </form>
  <h3>Code HTML</h3>
  <pre>
      <code>
      <AceEditor
      height={calcHeight(10)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={true}
      mode="html"
      theme="monokai"
      value={`<div class="nice-select">
      <div>Filtrer</div>
      <input class="choose-list" type="checkbox" id="all" value="" name="choose-list" />
      <label class="choose-list" for="all">Tous</label>
      <input class="choose-list" type="checkbox" id="dog" value="dog" name="choose-list"/>
      <label class="choose-list" for="dog">Dog</label>
      <input class="choose-list" type="checkbox" id="hamster" value="hamster" name="choose-list"/>
      <label class="choose-list" for="hamster">Hamster</label>
      <div>Modifier le filte</div>
  </div>`}
        />
      </code>
      </pre>
  <h3>Code CSS</h3>
      <pre>
      <code>
      <AceEditor
      height={calcHeight(13)}
      width="100%"
      fontSize={16}
      showPrintMargin={false}
      showGutter={true}
      mode="css"
      theme="monokai"
      value={`.nice-select{width:250px;display:flex;flex-direction:column;position:relative;height:46px}
.nice-select input.choose-list{display:none}
.nice-select > div:first-child{border-bottom:1px solid #12131a;color:#fff;background-color:#313445;cursor:pointer;padding:1rem}
.nice-select > div:first-child::after,.nice-select input.choose-list:checked + label ~ div::after{border:2px solid #888;content:"";position:absolute;width:10px;height:10px;border-top:0;border-left:0;transform:rotate(45deg);margin-right:15px;margin-top:5px;right:0}
.nice-select > label{color:#fff;background-color:#313445;border-bottom:1px solid #12131a;opacity:0;transform-origin:top center;transition:all .1s ease-out;padding:1rem;font-size:1.6rem;padding-left:45px}
.nice-select:hover > label{opacity:1;display:flex;flex-direction:column}
.nice-select input.choose-list + label:before{background-color:#000;content:"";position:absolute;margin-left:-30px;width:20px;height:20px;border-top:0;border-left:0;transform:rotate(0deg);opacity:1;transition:all .2s ease-out;transition:scale(1);margin-top:2px;border-radius:5px}
.nice-select input.choose-list:checked + label:before{border:3px solid #60d6a7;content:"";position:absolute;margin-left:-25px;width:5px;height:10px;border-top:0;border-left:0;transform:rotate(45deg);opacity:1;transition:all .2s ease-out;transition:scale(1);margin-top:2px;border-radius:0;background-color:transparent}
.nice-select input.choose-list:checked + label{background-color:#000}
.nice-select > div:last-child{border-bottom:1px solid #12131a;background-color:#313445;color:#fff;cursor:pointer;padding:1rem;transition:all .1s ease-out;opacity:0}
.nice-select input.choose-list:checked + label ~ div{display:block;position:absolute;width:100%;padding-left:3rem;opacity:1}
.nice-select input.choose-list:checked + label ~ div::before{border:3px solid #60d6a7;content:"";position:absolute;width:5px;height:10px;border-top:0;border-left:0;transform:rotate(45deg);left:0;margin-top:3px;margin-left:10px}`}
/>
      </code>
      </pre>

      </div>
    )
}
